// src/pages/LoginPage.jsx
import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function LoginPage() {
  const navigate = useNavigate();
  const { user, loading: authLoading, error, login } = useAuth();

  const [form, setForm] = useState({ username: "", password: "" });
  const [submitting, setSubmitting] = useState(false);
  const [localError, setLocalError] = useState("");

  useEffect(() => {
    if (user) {
      if (user.role === "admin") navigate("/admin/dashboard");
      else navigate("/dashboard");
    }
  }, [user, navigate]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setLocalError("");
  };

  const handleSubmit = async () => {
    if (!login) return;
    setSubmitting(true);
    setLocalError("");

    const loggedUser = await login(form.username.trim(), form.password);

    if (!loggedUser) {
      setSubmitting(false);
      return;
    }

    if (loggedUser.role === "admin") navigate("/admin/dashboard");
    else navigate("/dashboard");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="w-full max-w-md bg-white rounded-xl shadow-md p-8">
        <h1 className="text-2xl font-bold text-center mb-6">Přihlášení</h1>

        {(error || localError) && (
          <div className="mb-4 text-sm text-red-600">
            {localError || error}
          </div>
        )}

        {/* ❗ form už NEPROVÁDÍ SUBMIT */}
        <form onSubmit={(e) => e.preventDefault()} className="space-y-4">
          <input
            type="text"
            name="username"
            placeholder="Uživatelské jméno"
            value={form.username}
            onChange={handleChange}
            required
            className="w-full border rounded-lg px-3 py-2"
            autoComplete="off"
          />

          <input
            type="password"
            name="password"
            placeholder="Heslo"
            value={form.password}
            onChange={handleChange}
            required
            className="w-full border rounded-lg px-3 py-2"
            autoComplete="off"
          />

          <button
            type="button"           // 🔥 button už není submit
            onClick={handleSubmit}  // 🔥 manual trigger
            disabled={submitting || authLoading}
            className={`w-full py-2 rounded-lg text-white font-semibold ${
              submitting || authLoading
                ? "bg-blue-300"
                : "bg-blue-600 hover:bg-blue-700"
            }`}
          >
            {submitting || authLoading ? "Přihlašuji…" : "Přihlásit se"}
          </button>
          <div className="flex justify-end">
            <Link
              to="/forgot-password"
              className="text-sm text-blue-600 hover:underline"
            >
              Zapomenuté heslo?
            </Link>
          </div>          
        </form>
      </div>
    </div>
  );
}
